import React from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import OrganizationListing from "./OrganizationListing";

const Organization = () => {
  const breadcrumbItems = [
    { title: "Org", link: "" },
    { title: "Organization", link: "/org/org" },
  ];

  // document.title="Org"
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card>
            <OrganizationListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Organization;
